import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { deleteQuizRequested } from 'features/quizzes/actions';

export function* deleteQuizSaga(action: ReturnType<typeof deleteQuizRequested>) {
  yield call(SignalingSocket.send, { event: 'deleteQuiz', data: { id: action.payload } });
}
